/**
 * Length and character rules for the sign-up / sign-in fields.
 *
 * Kept in step with the UpVibe Android app (fragment_sign_up.xml maxLength and
 * SignUpViewModel.isWellFormedName) so an account created on the web or on the
 * phone is held to the same rules. The maxLength values are also set on the
 * inputs, so the browser stops typing/pasting past the limit; the validators
 * below are the submit-time check that shows the message.
 */
export const NAME_MAX_LEN = 50;
export const USERNAME_MAX_LEN = 30;
// 150, not the usual 254: registration stores the email as auth_user.username,
// which is varchar(150) — a longer email crashes the insert on the server.
export const EMAIL_MAX_LEN = 150;
export const PASSWORD_MAX_LEN = 128;

// Letters of any script (plus their combining marks, which Indian scripts need)
// and the punctuation real names use: space, hyphen, apostrophe.
const NAME_ALLOWED = /^[\p{L}\p{M} '-]+$/u;
const NAME_HAS_LETTER = /\p{L}/u;
const NAME_DISALLOWED = /[^\p{L}\p{M} '-]/gu;

/**
 * Drops every character a name may not contain, so numbers and symbols simply
 * cannot be typed (or pasted) into the First/Last Name inputs.
 */
export function sanitizePersonName(value) {
  return (value || '').replace(NAME_DISALLOWED, '');
}

/**
 * Returns an error message for a first/last name, or '' when it is fine.
 * "Anne-Marie", "O'Brien" and "लोकेश" pass; "12345", "John1" and "Ja#ne" do not.
 */
export function validatePersonName(value, label, { required = true } = {}) {
  const name = (value || '').trim();
  if (!name) return required ? `${label} is required.` : '';
  if (name.length > NAME_MAX_LEN) return `${label} must be at most ${NAME_MAX_LEN} characters.`;
  if (!NAME_ALLOWED.test(name) || !NAME_HAS_LETTER.test(name)) {
    return `${label} can only contain letters, spaces, hyphens (-) and apostrophes (').`;
  }
  return '';
}
